let supplementals = [];

export const setSupplementals = (data) => {
  supplementals = data;
};

export const getSupplementalsByEntity = (entity) => {
  return supplementals.filter((s) => {
    return (
      !s.supportedEntityTypeConfiguration?.length ||
      s.supportedEntityTypeConfiguration.some(
        (supportedEntity) => supportedEntity.entityType === entity,
      )
    );
  });
};

export const getSupplementals = () => supplementals;
